import { Box } from '@material-ui/core';
import { useState } from 'react';

import { OnboardingDetailsOption } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/components/LastCartsSelector/entities/OnboardingDetailsOption';
import { LastItemSelectorWrapper } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/components/LastItemSelectorWrapper';
import { StoredBorrowerOnboardingDetails } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/types';
import { useMerchantPosContext } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/_shared/contexts/MerchantPosContext';
import { OnboardingDetailsRepositoryFactory } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/entities/OnboardingDetailsRepositoryFactory';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface StoredBorrowerMenuItemProps {
  borrowerOnboardingDetails: StoredBorrowerOnboardingDetails;
  getBorrowerOnboardingDetails: () => void;
}

export const StoredBorrowerMenuItem = ({
  borrowerOnboardingDetails,
  getBorrowerOnboardingDetails,
}: StoredBorrowerMenuItemProps) => {
  const { palette } = useCustomTheme();
  const { agent } = useMerchantPosContext();

  const [merchantRepository] = useState(OnboardingDetailsRepositoryFactory.getRepository());

  const { dateOfCart, roleTypeIcon, borrowerName, borrowerEmail } = new OnboardingDetailsOption(
    borrowerOnboardingDetails,
  );

  const onRemove = () => {
    merchantRepository.remove(borrowerOnboardingDetails.id, agent.id);
    getBorrowerOnboardingDetails();
  };

  return (
    <LastItemSelectorWrapper removeItem={onRemove}>
      <Box display={'flex'} gridGap={8} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
        <Icon size={18} color={palette.secondary.main}>
          {roleTypeIcon}
        </Icon>
        <Box gridGap={2} display={'flex'} flexDirection={'column'}>
          <Font variant="body2" color="textPrimary">
            <strong>{borrowerName}</strong>
          </Font>
          <FlexRow>
            <Font variant="caption" color="textSecondary">
              {dateOfCart}
              {' · '}
              {borrowerEmail}
            </Font>
          </FlexRow>
        </Box>
      </Box>
    </LastItemSelectorWrapper>
  );
};
